<template>
  <div v-if="getComponent" :class="$style.container">
    <component :is="getComponent" />
  </div>
</template>

<script>
const PAYMENT_SYSTEMS = {
  VISA: 'Visa',
  MASTERCARD: 'MasterCard',
  MIR: 'Mir',
  MAESTRO: 'Maestro',
  'AMERICAN-EXPRESS': 'AmericanExpress',
  'DINERS-CLUB': 'Diners',
  JCB: 'JCB',
  UZCARD: 'UzCard',
  HUMO: 'Humo',
};

export default {
  name: 'PaymentSystemLogo',
  props: {
    variant: {
      type: String,
      required: true,
    },
  },
  computed: {
    getComponent() {
      const logoComponent = PAYMENT_SYSTEMS[this.variant];

      if (this.$validate.isUndefined(logoComponent)) {
        return null;
      }

      return () => import('atoms/payment-systems/' + logoComponent);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +size(50px, 32px)
    +flexbox
    +justify-content(center)
    +align-items(center)
    padding: 6px 8px
    border-radius: 5px
    background-color: rgba(255, 255, 255, 0.5)
</style>
